import GiftCardLoader from "ui/giftcards/components/loader/GiftCardLoader";
import GiftCardSegment from "ui/giftcards/components/segment/GiftCardSegment";
import { GiftCardsListProps } from "./GiftCardsList.types";
import { useTranslate } from "ui/locale";
import { Typography } from "@commonlibs";

function GiftCardsList({ giftCards, isLoading }: GiftCardsListProps) {
    const translate = useTranslate();
    if (isLoading) {
        return <GiftCardLoader />;
    }

    return (
        <div style={{ marginTop: "10px" }}>
            {Object.keys(giftCards).length > 0 ? (
                Object.keys(giftCards).map((category) => <GiftCardSegment key={category} title={category} data={giftCards[category]} />)
            ) : (
                <Typography textAlign="center" variant="body3Strong" style={{ marginTop: "15px" }}>
                    {translate("noGiftCardsAvailable")}
                </Typography>
            )}
        </div>
    );
}

export default GiftCardsList;
